
if (window.hasOwnProperty('sessionSecondsRemaining')) {
  window.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      window.location.href = encodeURI(document.location.origin);
    }, (<any>window).sessionSecondsRemaining * 1000);
  });
}